// @ts-nocheck
import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Video, Utensils, Sparkles, LogOut, UserCircle, Settings as SettingsIcon } from 'lucide-react';
import { supabase } from '../utils/supabaseClient';

interface HeaderProps {
  userEmail: string | null;
  onSignOut: () => void;
  onViewProfile: () => void; // Nueva prop para ver el perfil
  onOpenSettings?: () => void;
}

const Header: React.FC<HeaderProps> = ({ userEmail, onSignOut, onViewProfile, onOpenSettings }) => {
  const handleSignOut = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) {
      console.error('Error al cerrar sesión:', error);
      alert('Error al cerrar sesión.');
    } else {
      onSignOut();
    }
  };

  return (
    <motion.div 
      className="text-center mb-12"
      initial={{ opacity: 0, y: -30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center gap-3">
          <motion.div 
            className="p-3 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.3, duration: 0.5, type: "spring" }}
          >
            <Video className="w-8 h-8 text-white" />
          </motion.div>
          <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
            FoodSpotter
          </h1>
          <motion.div 
            className="p-3 bg-gradient-to-br from-purple-500 to-pink-500 rounded-2xl"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.3, duration: 0.5, type: "spring" }}
          >
            <Utensils className="w-8 h-8 text-white" />
          </motion.div>
        </div>

        {userEmail ? (
          <div className="flex items-center gap-4">
            <motion.button
              onClick={onOpenSettings}
              className="flex items-center gap-2 text-gray-700 font-medium px-3 py-2 rounded-xl hover:bg-gray-100 transition-colors"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              aria-label="Ajustes"
              title="Ajustes"
            >
              <SettingsIcon className="w-5 h-5" />
              <span className="hidden sm:inline">Ajustes</span>
            </motion.button>
            <motion.button
              onClick={onViewProfile}
              className="flex items-center gap-2 text-gray-700 font-medium px-3 py-2 rounded-xl hover:bg-gray-100 transition-colors"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <UserCircle className="w-5 h-5" />
              <span>{userEmail}</span>
            </motion.button>
            <motion.button
              onClick={handleSignOut}
              className="px-4 py-2 bg-red-500 text-white rounded-xl font-semibold flex items-center gap-2 hover:bg-red-600 transition-colors"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <LogOut className="w-4 h-4" />
              Salir
            </motion.button>
          </div>
        ) : (
          <div className="flex items-center gap-2 text-gray-500 font-medium">
            <UserCircle className="w-5 h-5" />
            <span>Invitado</span>
          </div>
        )}
      </div>

      <motion.p 
        className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.6 }}
      >
        Descubre restaurantes increíbles a través de videos virales de TikTok, Instagram, YouTube y Facebook. 
        <span className="font-semibold text-gray-800"> ¡Encuentra tu próxima aventura culinaria!</span>
      </motion.p>

      <motion.div 
        className="flex flex-wrap justify-center gap-6 text-sm"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.7, duration: 0.5 }}
      >
        <div className="flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full border border-gray-200">
          <MapPin className="w-4 h-4 text-red-500" />
          <span className="text-gray-700 font-medium">Ubicaciones Exactas</span>
        </div>
        <div className="flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full border border-gray-200">
          <Sparkles className="w-4 h-4 text-yellow-500" />
          <span className="text-gray-700 font-medium">IA Inteligente</span>
        </div>
        <div className="flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full border border-gray-200">
          <Video className="w-4 h-4 text-blue-500" />
          <span className="text-gray-700 font-medium">Múltiples Plataformas</span>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default Header;